/**
 * Created by guoliangfang on 2017/8/22.
 */
import React from 'react';
import { withRouter } from 'react-router-dom';
import SubAccountForm from '../SubAccountForm';

class EditSubAccount extends React.Component {
    constructor(props) {
        super(props);
        this.id = this.props.match.params.id;
    }
    render() {
        return (
            <div>
                <SubAccountForm id={this.id} edit={true} />
            </div>
        );
    }
}

export default withRouter(EditSubAccount);



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/EditSubAccount/index.js